import React from 'react';
import { CloseOutlined, InfoCircleFilled } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Space } from 'antd';
import { useTranslate } from '@tolgee/react';
import { TipsStatus, useSetCurrentChatPreference } from 'hooks/business/im/chatPreference';

export interface GuaranttedAssignTipsProps {
  className?: string;
}

const Box = styled.div`
  padding: 8px 16px;
  display: flex;
  background-color: #f0f4ff;
  font-size: 14px;
  align-items: center;
  justify-content: space-between;
`;

const Icon = styled(InfoCircleFilled)`
  color: orange;
`;

const ClzBtn = styled(CloseOutlined)`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
`;

const GuaranttedAssignTips = ({ className }: GuaranttedAssignTipsProps) => {
  const setPreference = useSetCurrentChatPreference();

  const { t } = useTranslate();

  return (
    <Box className={className}>
      <Space>
        <Icon />
        {t('scene.chatWorkspace.currentConversation.hint.guaranteedAssignmentNotice')}
      </Space>
      <ClzBtn
        onClick={() => {
          setPreference({
            grantedAssignTips: TipsStatus.Dismissed,
          });
        }}
      />
    </Box>
  );
};
export default React.memo(GuaranttedAssignTips);
